import {
  doc,
  setDoc,
  serverTimestamp,
  query,
  orderBy,
  collection,
  where,
  limit,
  getDocs
} from "firebase/firestore";

import { db } from "../firebase";
import Cookies from "js-cookie";

export const Create_page = async (data) => {

  const {
    page_name,
    page_description,
    page_keywords,
    pageuid,
    slug,
    companyuid
  } = data || {};

  // ================= VALIDATION =================
  if (!page_name?.trim()) {
    return { success: false, error: "Missing page name" };
  }

  if (!page_description?.trim()) {
    return { success: false, error: "Missing page description" };
  }

  if (!page_keywords?.trim()) {
    return { success: false, error: "Missing page keywords" };
  }

  if (!slug?.trim()) {
    return { success: false, error: "Missing slug" };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");

  if (!sessiontoken || !guid || !companyuid) {
    return { success: false, error: "Session expired. Please relogin." };
  }

  try {

    const servicetablename = "companies";
    const tablename = "pages";

    const pagesRef = collection(db, servicetablename, companyuid, tablename);

    // ================= CHECK DUPLICATE SLUG =================
    const slugQuery = query(
      pagesRef,
      where("slug", "==", slug)
    );

    const slugSnapshot = await getDocs(slugQuery);

    if (!slugSnapshot.empty) {
      const existingDoc = slugSnapshot.docs[0].data();

      if (existingDoc.pageuid !== pageuid) {
        return { success: false, error: "Slug already exists" };
      }
    }

    // ================= HANDLE PAGEUID =================
    let finalPageuid = pageuid;

    if (!finalPageuid) {
      finalPageuid = Date.now().toString();
    }

    const docRef = doc(
      db,
      servicetablename,
      companyuid,
      tablename,
      finalPageuid
    );

    // ================= CHECK EXISTING DOC =================
    const existingQuery = query(
      pagesRef,
      where("pageuid", "==", finalPageuid),
      limit(1)
    );

    const existingSnapshot = await getDocs(existingQuery);

    const isNew = existingSnapshot.empty;

    // ================= INDEX NUMBER (ONLY NEW) =================
    let indexnumber = null;

    if (isNew) {
      const indexQuery = query(
        pagesRef,
        orderBy("indexnumber", "desc"),
        limit(1)
      );

      const indexSnapshot = await getDocs(indexQuery);

      if (!indexSnapshot.empty) {
        const lastIndex = indexSnapshot.docs[0].data().indexnumber || 0;
        indexnumber = lastIndex + 1;
      } else {
        indexnumber = 1;
      }
    }

    // ================= SAVE =================
    await setDoc(
      docRef,
      {
        ...data,
        pageuid: finalPageuid,
        guid,
        companyuid,
        sessiontoken,

        update_date_time: serverTimestamp(),

        // ✅ ONLY NEW PAGE
        ...(isNew && {
          date_time: serverTimestamp(),
          indexnumber
        })

      },
      { merge: true }
    );

    return { success: true };

  } catch (err) {
    console.error("❌ Error saving page:", err);

    return {
      success: false,
      error: err.message || "Unknown error"
    };
  }
};